const fontOptions = [
  {
    value: 'arial', label: 'Arimo', id: 'arial', font: 'arial',
  },
  {
    value: 'bookman', label: 'Libre Baskerville', id: 'bookman', font: 'bookman',
  },
  {
    value: 'courier', label: 'Courier Prime', id: 'Courier', font: 'courier',
  },
  {
    value: 'cursive', label: 'Kalam', id: 'cursive', font: 'cursive',
  },
  {
    value: 'fantasy', label: 'Oswald', id: 'fantasy', font: 'fantasy',
  },
  {
    value: 'helvetica', label: 'Lato', id: 'helvetica', font: 'helvetica',
  },
  {
    value: 'lucida console', label: 'Old Standard TT', id: 'lucida console', font: 'lucida console',
  },
  {
    value: 'monospace', label: 'Fira Mono', id: 'monospace', font: 'monospace',
  },
  {
    value: 'open sans', label: 'Open Sans', id: 'open sans', font: 'open sans',
  },
  {
    value: 'roboto', label: 'Roboto', id: 'roboto', font: 'roboto',
  },
  {
    value: 'rubik', label: 'Rubik', id: 'rubik', font: 'rubik',
  },
  {
    value: 'sans-serif', label: 'Nunito Sans', id: 'sans-serif', font: 'sans-serif',
  },
  {
    value: 'serif', label: 'Playfair Display', id: 'Serif', font: 'serif',
  },
  {
    value: 'tahoma', label: 'Signika', id: 'tahoma', font: 'tahoma',
  },
  {
    value: 'times new roman', label: 'Tinos', id: 'times new roman', font: 'times new roman',
  },
  {
    value: 'verdana', label: 'Jost', id: 'verdana', font: 'verdana',
  },
];

export default fontOptions;
